import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "mb-4" };
const _hoisted_2 = { class: "input-group" };
const _hoisted_3 = ["disabled"];
const _hoisted_4 = { class: "d-flex align-items-center gap-3" };
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "ms-auto" };
const _hoisted_7 = { class: "badge bg-light text-dark" };
const _hoisted_8 = { key: 1 };
const _hoisted_9 = {
    class: "d-flex align-items-center justify-content-center",
    style: { "height": "400px" }
};
import { BListGroup, BListGroupItem, BModal, BSpinner } from 'bootstrap-vue-next';
import { computed, ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FavoriteManagerApp',
    setup(__props) {
        u.on('open.fav.collections', openFavCollections);
        let currentSiteId = null;
        let currentButton = null;
        const favModalOpen = ref(false);
        const loading = ref(false);
        const collections = ref([]);
        const favCount = computed(() => {
            return collections.value.filter((c) => c.favorited === '1').length;
        });
        async function openFavCollections(el, id) {
            currentSiteId = id;
            currentButton = el;
            collections.value = [];
            favModalOpen.value = true;
            collections.value = await loadFavCollections(id);
        }
        async function loadFavCollections(id) {
            loading.value = true;
            try {
                const res = await u.$http.get(`@favorite_ajax/collections?siteId=${id}`);
                return res.data.data;
            }
            finally {
                loading.value = false;
            }
        }
        async function toggleFavorite(collection) {
            const data = {
                collectionId: collection.id,
                siteId: currentSiteId,
            };
            try {
                if (collection.favorited === '1') {
                    collection.favorited = '0';
                    collection.count--;
                    await u.$http.delete('@favorite_ajax/removeSite', data);
                }
                else {
                    collection.favorited = '1';
                    collection.count++;
                    await u.$http.post('@favorite_ajax/addSite', data);
                }
                updateButtonIcon();
            }
            catch (e) {
                u.alert(e.message);
                throw e;
            }
        }
        function updateButtonIcon() {
            const icon = currentButton.querySelector('i');
            if (favCount.value === 0) {
                icon.classList.remove('far', 'fas');
                icon.classList.add('far');
            }
            else {
                icon.classList.remove('far', 'fas');
                icon.classList.add('fas');
            }
        }
        const newCollectionName = ref('');
        const creating = ref(false);
        function onNewInputKeydown() {
            createCollection();
        }
        async function createCollection() {
            creating.value = true;
            u.clearNotifies();
            try {
                const res = await u.$http.post('@favorite_ajax/newCollectionAndFAddSite', { title: newCollectionName.value, siteId: currentSiteId });
                const collection = res.data.data;
                collection.favorited = '1';
                collections.value.unshift(collection);
                newCollectionName.value = '';
                updateButtonIcon();
                u.notify('新增成功', 'success');
            }
            finally {
                creating.value = false;
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(BModal), {
                title: "選擇收藏夾",
                modelValue: favModalOpen.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((favModalOpen).value = $event)),
                "hide-footer": ""
            }, {
                default: _withCtx(() => [
                    (!loading.value)
                        ? (_openBlock(), _createBlock(_unref(BListGroup), {
                            key: 0,
                            style: { "--bs-list-group-active-border-color": "var(--bs-list-group-border-color)" }
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                    _createElementVNode("div", _hoisted_2, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((newCollectionName).value = $event)),
                                            onKeypress: _withKeys(onNewInputKeydown, ["enter"])
                                        }, null, 544), [
                                            [_vModelText, newCollectionName.value]
                                        ]),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-primary",
                                            disabled: newCollectionName.value === '' || creating.value,
                                            onClick: createCollection
                                        }, _cache[2] || (_cache[2] = [
                                            _createElementVNode("i", { class: "far fa-plus" }, null, -1),
                                            _createTextVNode(" 新增收藏夾 ")
                                        ]), 8, _hoisted_3)
                                    ])
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collections.value, (collection) => {
                                    return (_openBlock(), _createBlock(_unref(BListGroupItem), {
                                        style: { "cursor": "pointer" },
                                        active: collection.favorited === '1',
                                        onClick: ($event) => (toggleFavorite(collection))
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_4, [
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("img", {
                                                        src: collection.cover,
                                                        alt: "image",
                                                        style: { "width": "100px" }
                                                    }, null, 8, _hoisted_5)
                                                ]),
                                                _createElementVNode("div", null, _toDisplayString(collection.title), 1),
                                                _createElementVNode("div", _hoisted_6, [
                                                    _createElementVNode("span", _hoisted_7, _toDisplayString(collection.count), 1)
                                                ])
                                            ])
                                        ]),
                                        _: 2
                                    }, 1032, ["active", "onClick"]));
                                }), 256))
                            ]),
                            _: 1
                        }))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(_unref(BSpinner), { type: "grow" })
                            ])
                        ]))
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
